import { render, staticRenderFns } from "./my-marquee.vue?vue&type=template&id=03dce5b6&scoped=true&"
import script from "./my-marquee.vue?vue&type=script&lang=js&"
export * from "./my-marquee.vue?vue&type=script&lang=js&"
import style0 from "./my-marquee.vue?vue&type=style&index=0&id=03dce5b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dce5b6",
  null
  
)

export default component.exports